// src/components/store/sections/product-cards/Variant42VinylDiscPortalFuchsiaGlowCard.tsx
"use client";

import Image from "next/image";
import Link from "next/link";
import { Star, ShoppingBag, Check, Sparkles } from "lucide-react";
import { UniversalProductCardProps, useCardActions } from "./useCardActions";

export default function Variant42VinylDiscPortalFuchsiaGlowCard({
  product,
  subdomain = "nextlook",
}: UniversalProductCardProps) {
  const {
    productImg,
    productName,
    productUrl,
    categoryName,
    rating,
    currentPrice,
    discountPercent,
    added,
    handleAddToCart,
  } = useCardActions(product, subdomain);

  return (
    <div className="w-full h-full bg-white rounded-[32px] border-2 border-fuchsia-200 p-4 shadow-md hover:shadow-xl transition-all duration-300 flex flex-col items-center justify-between text-center group select-none">
      <div className="w-full flex items-center justify-between text-[10px] font-black">
        <span className="px-2.5 py-0.5 rounded-full bg-fuchsia-50 text-fuchsia-700 uppercase truncate max-w-[120px]">
          {categoryName}
        </span>
        <span className="px-2 py-0.5 rounded-full bg-slate-900 text-white font-mono">
          -{discountPercent}%
        </span>
      </div>

      <Link href={productUrl} className="relative my-2 flex items-center justify-center">
        <div className="w-40 h-40 rounded-full bg-gradient-to-tr from-fuchsia-500 to-pink-600 p-1.5 shadow-lg group-hover:rotate-6 transition-transform duration-500">
          <div className="w-full h-full rounded-full bg-white flex items-center justify-center p-3 relative overflow-hidden">
            <div className="absolute inset-2 rounded-full border border-dashed border-fuchsia-200 pointer-events-none" />
            <div className="relative w-28 h-28">
              <Image src={productImg} alt={productName} fill unoptimized className="object-contain group-hover:scale-110 transition-transform" />
            </div>
          </div>
        </div>
      </Link>

      <div className="w-full space-y-1">
        <div className="flex items-center justify-center gap-1 text-amber-400 text-xs font-bold">
          <Star className="w-3.5 h-3.5 fill-amber-400" />
          <span className="text-slate-700">{rating.toFixed(1)}</span>
          <Sparkles className="w-3 h-3 text-fuchsia-700 ml-1" />
        </div>
        <Link href={productUrl} className="block">
          <h3 className="text-sm font-black text-slate-900 truncate hover:underline">{productName}</h3>
        </Link>
        <div className="text-xl font-black font-mono text-fuchsia-700">
          ৳{currentPrice.toLocaleString()}
        </div>
      </div>

      <button
        type="button"
        onClick={(e) => handleAddToCart(e)}
        className="w-full mt-3 py-2.5 rounded-full bg-gradient-to-r from-fuchsia-500 to-pink-600 text-white font-black text-[10px] uppercase tracking-wider shadow-md hover:opacity-95 active:scale-95 transition-all cursor-pointer flex items-center justify-center gap-1.5"
      >
        {added ? <Check className="w-3.5 h-3.5" /> : <ShoppingBag className="w-3.5 h-3.5" />}
        <span>{added ? "Added to Bag" : "Add to Cart"}</span>
      </button>
    </div>
  );
}
